<template>
    <div>
        <trial-end-clock
            :title="$t.__('common.labels.account_is_now_inactive')"
            :subtitles="[
                $t.__('common.labels.subscription_expired'),
                $t.__('pages.errors.ErrorBasic.to_continue_renew_subscription'),
            ]"
        >
            <CompassButton
                v-if="hasActiveCart"
                :label="$t.__('pages.errors.ErrorBasic.validate_offer')"
                size="large"
                @click="onClickValidateCart"
            />
            <CompassButton
                v-else
                :label="$t.__('common.actions.contact_sales')"
                size="large"
                @click="window.MySupport.getForm()"
            />
            <p class="typographies-paragraph-medium-bold help-message__container">
                {{ $l10n.__('Ou revenir sur') }}
                <CompassLink
                    :label="$t.__('common.labels.sellsy_short_url')"
                    size="large"
                    link="https://go.sellsy.com"
                />
            </p>
        </trial-end-clock>
    </div>
</template>

<script>
import TrialEndClock from 'vcomponents/pages/errors/TrialEndClock.vue';

export default {
    components: {
        TrialEndClock,
    },
    props: {
        hasActiveCart: {
            type: Boolean,
            required: true,
        },
        cartLink: String,
        provider: {
            type: String,
            required: false,
            default: 'stripe',
        },
    },
};
</script>

<style lang="scss" scoped>
.help-message__container {
    margin: 0;
}
</style>
